import { Routes } from '@angular/router';
import { AuthenticationGuard } from './guards/authentication.guard';

export const routes: Routes = [
  /*
  {
    path: 'dev',
    canActivate: [ComponentTestViewGuard],
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'component-test',
      },
      {
        path: 'component-test',
        loadComponent: () =>
          import('./views/component-test-view/component-test-view.component').then(
            (m) => m.ComponentTestViewComponent
          ),
      },
    ],
  },
  */
  {
    path: '',
    canActivate: [AuthenticationGuard],
    children: [
      {
        path: 'auth',
        data: {
          authUrl: true,
        },
        loadChildren: () =>
          import('./modules/authentication/authentication.routes').then((m) => m.AUTHENTICATION_ROUTES),
      },
      {
        path: '',
        canActivate: [AuthenticationGuard],
        children: [
          {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
          },
          {
            path: 'dashboard',
            loadChildren: () =>
              import('./modules/dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
          },
          {
            path: 'jobs',
            loadChildren: () => import('./modules/jobs/jobs.routes').then((m) => m.JOBS_ROUTES),
          },
          {
            path: 'talents',
            loadChildren: () => import('./modules/talents/talents.routes').then((m) => m.TALENTS_ROUTES),
          },
          {
            path: 'campaigns',
            loadChildren: () =>
              import('./modules/campaigns/campaigns.routes').then((m) => m.CAMPAIGNS_ROUTES),
          },
          {
            path: 'reports',
            loadChildren: () =>
              import('./modules/performance-analysis/performance-analysis.routes').then(
                (m) => m.PERFORMANCE_ANALYSIS_ROUTES
              ),
          },
          {
            path: 'settings',
            children: [
              {
                path: 'profile',
                loadChildren: () =>
                  import('./modules/settings-profile/settings-profile.routes').then(
                    (m) => m.SETTINGS_PROFILE_ROUTES
                  ),
              },
              {
                path: 'company',
                loadChildren: () =>
                  import('./modules/settings-company/settings-company.routes').then(
                    (m) => m.SETTINGS_COMPANY_ROUTES
                  ),
              },
            ],
          },
          {
            path: 'search',
            loadChildren: () =>
              import('./modules/search/search.routes').then((m) => m.SEARCH_ROUTES),
          },
          {
            path: 'errors',
            children: [
              {
                path: '404',
                loadComponent: () =>
                  import('./modules/errors/views/error-404-view/error-404-view.component').then(
                    (m) => m.Error404ViewComponent
                  ),
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/errors/404',
  },
];
